import { showError } from '../utils/utils';
const HOSTNAME = import.meta.env.VITE_API_URL;
const X_API_KEY = import.meta.env.VITE_X_API_KEY;
// console.log("API HOSTNAME:", HOSTNAME);
var token = localStorage.getItem('token');
// console.log(token)
export async function makeAPI(url, method = "POST", credentials = false, data = {}) {
// console.log(token)
    token = localStorage.getItem('token');

    const headers = {
        "Content-Type": "application/json",
        'x-api-key': X_API_KEY
    }

    if (credentials) {
        // refetch if token true;
        headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await fetch(`${HOSTNAME}${url}`, {
        method: method,
        headers: headers,
        body: JSON.stringify(data)
    });
    let responseData = await response.json();
    // console.log("API Response Status:", responseData.status);
    if(responseData.status === 'UA'){
        // alert("Unauthorized Access. Please login again.");
        showError("Unauthorized Access. Please login.");
        console.log("Unauthorized Access. Updating auth state...");
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.clear();
        window.dispatchEvent(new CustomEvent("auth:updated"));
    }
    
    // console.log("API Response:", await response.json());
    return responseData;
}
export async function makeApiCall_v1(url, method= "POST",credentials = false, data) {
   
    let options = {
        method: method,
        headers: {
            // "Content-Type": "application/json",
            'x-api-key': X_API_KEY
        },
    };

    if (data) {
        options.body = data;
    }
    if (credentials) {
        options.headers['Authorization'] = `Bearer ${token}`;
    }
    const response = await fetch(`${HOSTNAME}${url}`, options);
    const responseData = await response.json();
    // console.log("API Response Status ---:", responseData.status);
    if(responseData.status === 'UA'){
        // alert("Unauthorized Access. Please login again.");
        showError("Unauthorized Access. Please login.");
        console.log("Unauthorized Access. Updating auth state...");
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.clear();
        window.dispatchEvent(new CustomEvent("auth:updated"));
    }
    return responseData;
}
